/*
 * vue.js
 * @author Martin Appelmann <martin@movearound.fit>
 * @copyright 2022 movearound GmbH
 */

import { createApp } from 'vue'
import Crawler from './vue/crawler'
import PartnerMap from './vue/partner-map'
import VueMapboxTs from "vue-mapbox-ts";

const app = createApp({})
app.use(VueMapboxTs)

app.component('crawler', Crawler)
app.component('partner-map', PartnerMap)

app.mount('#app')
